/**
 * openInNewTab — opens a URL in a new browser tab without ever touching
 * the original tab. Uses the anchor-click pattern because
 * `window.open(url, '_blank', 'noopener,noreferrer')` returns `null` in
 * Chromium-based browsers (by WHATWG spec design when `noopener` is
 * specified), which makes a naive `if (!w)` popup-block fallback fire
 * incorrectly and double-navigate the parent tab.
 *
 * Trade-off: we can't detect popup-block reliably this way either, but
 * preserving the parent-tab context is the more important user-visible
 * requirement.
 */
export function openInNewTab(url) {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
